<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div id="groupModal11" class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop style="min-width: 100%;">
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body">
                          <div class="maheading_2">
                                <h5 class="modal-title">Promote to Mentor</h5>
                          </div>  

                          <div class="col-12">
                            <div class="row">
                              <div class="col-12 pt-2">
                                {{ firstName }} {{ lastName }}
                              </div>
                              <div class="col-12 pt-1">
                                {{ email }}
                              </div>
                              <div class="col-12 pt-1">
                                {{ phoneNo }}
                              </div>
                            </div>

                            <div class="row" v-if="menteesApprentices.length > 0">
                              <div class="col-12 p-0 mt-3">
                                <label
                                    for="mentor"
                                    class="col-12 bold">Assign Mentees: <span class="required">*</span></label>
                                    
                                  <div class="ml-3" v-if="menteesApprentices.length == 0">No mentees added, yet!</div>

                                  <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in menteesApprentices">
                                    <div class="custom-control custom-checkbox"  style="padding-left: 35px !important;">
                                      <input name="Mentees" type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_mentee_' + option.id" v-model="assign_mentees" v-validate="'required'">
                                      <label class="custom-control-label" :for="form_type + '_mentee_' + option.id">{{ option.first_name + ' ' + option.last_name }}</label>
                                    </div>
                                  </div>
                                  <div v-show="verrors.has('Mentees')" class="pl-4 validate-warning-msg">You have to assign Mentees</div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-12 pt-3">
                              Promoting {{ firstName }} to mentor will allow {{ firstName }} to be a mentor to new mentees, while still being a mentee tracking current progress. You can update assigned mentors and other mentees to {{ firstName }}.
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-12 p-3">
                              After promoting {{ firstName }} to a mentor role, {{ firstName }} will continue to use a mentee seat. To convert {{ firstName }} to mentor-only role, please contact Mentor Mentee support.
                              </div>
                            </div>


                            <div class="submit margin-bottom-15 mt-3" style="text-align: center;">
                              <button :disabled="disable_add_btn" type="submit" class="btn btn-info ma-blue-btn" @click="onSubmit()">Promote to Mentor</button>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer mb-5"></div>
                    </div>
                </div>
            </div>
        </transition>



    </div>
  </div>

</template>



<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import { store } from '../../store/store';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: ['isModalVisible'],
  data: function () {
    return {
      menteesApprentices: [],
      menteeId: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNo: '',
      assign_mentees: [],
      landingPage: 'adminconsole',

    };
  },
  computed: {

  },
  methods: {
    hide() {
      this.$emit('close');
    },
    doFormReset() {
      this.$validator.reset();
    },
    navigate(path) {
      router.push(path);
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result) {
          return;
        }
        
        this.createMentor();
      })
      .catch(() => {

      });
    },
    createMentor() {
      this.disable_add_btn = true;
        axios('/promote-mentor',
          {
            method: 'POST',
            data: {
              "menteeId": this.menteeId,
              "accountId": this.$store.state.user_accountid,
              "assign_mentees": this.assign_mentees,
            }
          },
        )
        .then(response => {
          this.disable_add_btn = false;
          let routeData = this.$router.resolve({name: this.landingPage});
          window.open(routeData.href, '_self');
        })
        .catch(error => {
          this.disable_add_btn = false;
        });


    },
    initial(menteeId) {
      this.menteeId = menteeId;
      axios('/desktop/v2/mentee-details/' + this.menteeId + '/' + this.$store.state.user_accountid,
        {
          method: 'GET',         
        },
      )
      .then(response => {
          this.firstName = response.data.mentee_first_name;
          this.lastName = response.data.mentee_last_name;
          this.email = response.data.mentee_email;
          this.phoneNo = response.data.mentee_phone_no;
      })
      .catch(error => {

      });   

      axios('/desktop/manager/manage-license', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          menteeId: this.menteeId,
        }
      })
      .then(resp => {
        let accountItems = resp.data;
        this.menteeCount = accountItems.menteesApprentices.length;
        // this.menteesApprentices = accountItems.menteesApprentices;

        let menteesApprentices = accountItems.menteesApprentices.filter(item => item.status == 'Active');
        this.menteesApprentices = menteesApprentices;
        
      })
      .catch(() => {
      });

      setTimeout(() => {
        let element = document.getElementById('groupModal11');    
        element.scrollIntoView(true);
      }, 2000); 


    }
    
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu
  },
  created: function() {
    
  }
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 1px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.receipt-heading {
  float: left;
  font-weight: normal;
  font-size: 14px;
  text-decoration: underline;
}
.receipt-heading-1{
  width: 18%;
}
.receipt-heading-4 {
  width: 22%;
  text-align: right;
}
.receipt-heading-3 {
  width: 30%; 
}
.receipt-heading-6 {
  width: 12%; 
}
.receipt-heading-2 {
  width: 18%;
}
.receipt {
  font-weight: normal;
  text-decoration: none;
  float: left;
  font-size: 13px;
  padding-top: 8px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;

}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #808080;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #4E8D23;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

</style>




// WEBPACK FOOTER //
// src/components/manager/promote_mentor.vue